// components/PWAProvider.tsx
// Provider per PWA e Service Worker

'use client';

import { useServiceWorker } from '@/hooks/useServiceWorker';

export default function PWAProvider() {
  // Registra il service worker
  useServiceWorker();

  // Non renderizza nulla, è solo per la logica
  return null;
}